// extracted by mini-css-extract-plugin
module.exports = {"borderLessFormItem":"ReferTo_borderLessFormItem__Oy68_","initImageUpload":"ReferTo_initImageUpload__y_vNG","inputNumberGroup":"ReferTo_inputNumberGroup__D__P9"};